import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function containsStringValidator(requiredString: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (typeof value === 'string' && value.toLowerCase() === requiredString.toLowerCase()) {
      return null;
    }
    return { containsString: { requiredString } };
  };
}
